<template>
  <div>
    <el-tag size="mini" v-if="String(status)==='10'" type="primary">待确认</el-tag>
    <el-tag size="mini" v-else-if="String(status)==='20'" type="warning">已确认</el-tag>
    <el-tag size="mini" v-else-if="String(status)==='200'" type="danger">已完成</el-tag>
  </div>
</template>

<script>
export default {
  name: 'OrderStatusLable',
  props: {
    status: {
      type: Number | String,
      default: void 0
    }
  }
}
</script>

<style scoped>

</style>
